import { useEffect } from 'react';
import { formNewLaneEventPayload } from '../../../eventing/newLaneEventPayload';
import { CLICKSTREAM_EVENT_TYPE } from '../../../eventing/clickStreamEventSchema';
import { onsiteMessageEventPropTypes, defaultOnsiteMessageEventPropTypes } from './OnsiteMessageEventingTypes';
import { NBANewLaneEvent } from '../../../eventing/NBANewLaneEvent';
import { NBA_CLICKSTREAM_EVENT_TYPE } from '../../../eventing/nbaClickstreamEventSchema';
import { formNBANewLaneEventPayload } from '../../../eventing/nbaNewLaneEventPayload';
import { ClickstreamEvent } from '../../../eventing/ClickstreamEvent';
export var useOnsiteMessagingClickstreamIntentToShowEvent = function useOnsiteMessagingClickstreamIntentToShowEvent(_ref) {
  var newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData,
      _ref$signalForTrigger = _ref.signalForTriggerTracking,
      signalForTriggerTracking = _ref$signalForTrigger === void 0 ? true : _ref$signalForTrigger;
  useEffect(function () {
    var clickstreamPayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTENT_TO_SHOW, newLaneEventData, additionalClickStreamData || {});

    if (signalForTriggerTracking) {
      ClickstreamEvent(clickstreamPayload);

      if ((newLaneEventData === null || newLaneEventData === void 0 ? void 0 : newLaneEventData.isNbaProcessed) === true) {
        NBANewLaneEvent(formNBANewLaneEventPayload(NBA_CLICKSTREAM_EVENT_TYPE.INTENT_TO_SHOW, newLaneEventData, ''));
      }
    } // eslint-disable-next-line zillow/react-hooks/exhaustive-deps

  }, [signalForTriggerTracking]);
};
useOnsiteMessagingClickstreamIntentToShowEvent.propTypes = onsiteMessageEventPropTypes;
useOnsiteMessagingClickstreamIntentToShowEvent.defaultProps = defaultOnsiteMessageEventPropTypes;